import * as ifhelp2015api from './ifhelp2015api';
import React from 'react';
import ReactDOMClient from 'react-dom/client';
import IfHelpPanel from './components/IfHelpPanel';
import { customizeChat } from './customize-chat';
import { getCookie } from './util/cookies';

const showPanel = () => {
    const iimclient = window.iimclient;
    const mypath = iimclient.mypath;
    // const myfullpath = iimclient.myfullpath;

    const hasLoadedStyleSheet = (namePattern) => {
        let hasLoaded = false;
        document.querySelectorAll('link[rel="stylesheet"]').forEach((elem) => {
            if (
                elem.getAttribute('href') &&
                elem.getAttribute('href').match(namePattern) &&
                !hasLoaded
            )
                hasLoaded = true;
        });
        return hasLoaded;
    };

    const loadStyleSheet = (url) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        link.type = 'text/css';
        document.head.appendChild(link);
    };

    if (!/if\.(no|dk|se|eu|fi)\//.test(window.location.href)) {
        loadStyleSheet('//fonts.googleapis.com/css?family=Open+Sans:600,400');
    }
    const styles = 'ifhelp2022.css';
    if (!hasLoadedStyleSheet(new RegExp(styles))) {
        loadStyleSheet(mypath + styles);
    }

    const renderIfHelpPanel = () => {
        const aside = document.createElement('aside');
        const reactApp = document.createElement('div');
        reactApp.id = 'react-app';
        aside.appendChild(reactApp);
        document.body.appendChild(aside);

        const root = ReactDOMClient.createRoot(reactApp);
        root.render(<IfHelpPanel />);
    };

    const getAccountId = () => {
        const page = window.location.href;
        const accountIds = {
            fi: '78006857-6CC0-4C9D-8654-89BE8A9E1BF8',
            dk: '3D6BF275-01F8-4DFA-8790-5D1A31C4DF61',
            no: 'D8F5A8A7-D02D-46ED-86CC-88F4F92D1DFB',
            se: '8F126DFB-3F0B-4E1B-89BC-2AD11B1944FF',
            test: '2F786A11-4288-45D8-A532-2E8C0DEEBAFC',
        };

        if (/[?&]dechatse/.test(page)) return accountIds.se;
        else if (/[?&]dechatno/.test(page)) return accountIds.no;
        else if (/[?&]dechatdk/.test(page)) return accountIds.dk;
        else if (/[?&]dechatfi/.test(page)) return accountIds.fi;
        else if (/[?&]dechattest/.test(page)) return accountIds.test;

        if (/atest.if.no\/privat\/forsikring2/.test(page)) return accountIds.se;
        else if (/atest.if.no\/privat\/chatbot\/declient/.test(page)) return accountIds.no;
        else if (/atest.if.fi\/henkiloasiakkaat\/new-chat-de/.test(page)) return accountIds.fi;

        const isTest = /test\./.test(window.location.origin);
        const isConnectBot = /#connectbot/.test(page);
        const isMobility = window.ifhelp2015api.isMobilityPagesUrl();

        const isSweden = /(www|minasidor|webshop).if.se/.test(page) || isConnectBot || isMobility;
        const isNorway =
            /(www|minesider|webshop).if.no/.test(page) || /www.vertikalhelse.no/.test(page);
        const isDenmark = /(www|minesider|webshop).if.dk/.test(page);
        const isFinland = /(www|omatsivut|minasidor|webshop(basketfi|-hs)?).if.fi/.test(page);

        const myfullpath = iimclient ? iimclient.myfullpath : '';
        const isMyBusiness = window.ifhelp2015api.getMyBusinessUrl().length > 0;
        const isMyBusinessSweden = isMyBusiness && /[?&]secom/.test(myfullpath);
        const isMyBusinessNorway = isMyBusiness && /[?&]ksb/.test(myfullpath);
        const isMyBusinessDenmark = isMyBusiness && /[?&]dkcom/.test(myfullpath);
        const isMyBusinessFinland = isMyBusiness && /[?&]finland/.test(myfullpath);

        const id =
            isTest && !isConnectBot
                ? accountIds.test
                : isSweden || isMyBusinessSweden
                ? accountIds.se
                : isNorway || isMyBusinessNorway
                ? accountIds.no
                : isDenmark || isMyBusinessDenmark
                ? accountIds.dk
                : isFinland || isMyBusinessFinland
                ? accountIds.fi
                : accountIds.test;

        return id;
    };

    const initializeGenericFunctions = () => {
        const isVisible = (el) =>
            !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);

        window.hasErrorMessages = () =>
            [...document.querySelectorAll('.errorMessage')].filter(isVisible).length > 0;

        window.hasItemsInShoppingCart = () => {
            const cookie = getCookie('basketCountCookie');
            return cookie ? /basketCount=[1-9]/.test(cookie) : false;
        };
    };

    const initializeMyBusinessFunctions = () => {
        const iimclient = window.iimclient;
        const language = iimclient ? iimclient.chatlang || iimclient.textlang : '';
        const isMyBusiness =
            window.ifhelp2015api && window.ifhelp2015api.getMyBusinessUrl().length > 0;

        window.isMyBusinessNorwegian = () => isMyBusiness && language === 'lang_no';
        window.isMyBusinessSwedish = () => isMyBusiness && language === 'lang_se';
        window.isMyBusinessDanish = () => isMyBusiness && language === 'lang_dk';
        window.isMyBusinessFinnish = () => isMyBusiness && language === 'lang_fi';
        window.isMyBusinessEnglish = () => isMyBusiness && language === 'lang_en';
    };

    const initializeDEChat = () => {
        initializeGenericFunctions();
        initializeMyBusinessFunctions();
        const id = getAccountId();
        const old = document.getElementById('DEChat');
        if (old && old.getAttribute('data-account-id') === id) {
            if (window.vngage) window.vngage.evaluateOpportunities();
            return;
        }
        if (old) {
            location.reload(); // Need to ask from Puzzel if there is a better way
            return;
        }
        window.customizeChat = customizeChat;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://account.psplugin.com/' + id + '/ps.js';
        script.id = 'DEChat';
        script.async = true;
        script.setAttribute('data-account-id', id);
        document.body.appendChild(script);
    };

    renderIfHelpPanel();
    initializeDEChat();
};

export { showPanel };
